import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { Tooltip } from '@/components/elementary/Tooltip';
import { Info } from '@/components/icons/Info';
import { HighlightIcon } from '@/components/page-builder/global/pricingV1/overview/HighlightIcon';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import styles from '../featureComparison/FeatureCell.module.css';
export function PlanHighlights(t0) {
  const $ = _c(10);
  const {
    pricingItem,
    yearly,
    className
  } = t0;
  const highlights = yearly ? pricingItem?.highlightsYearly : pricingItem?.highlightsMonthly;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-4.5 py-5 px-3.75", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pricingItem?.highlightsTitle) {
    t2 = pricingItem?.highlightsTitle && <Paragraph fontSize="bodyBoldMedium" className="text-neutral-light-100">{pricingItem?.highlightsTitle}</Paragraph>;
    $[2] = pricingItem?.highlightsTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== highlights) {
    t3 = highlights?.map(_temp);
    $[4] = highlights;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(highlight) {
  if (!highlight) {
    return null;
  }
  return <div key={highlight.id} className="flex items-start"><HighlightIcon icon={highlight.icon} /><CkEditorCSRRenderer htmlContent={highlight.text} className={styles["table-cell-content"]} defaultTypography="bodyMedium" />{highlight.tooltip ? <Tooltip content={highlight.tooltip}><span><Info className="text-neutral-light-400 size-4 top-1 relative shrink-0 ml-1" /></span></Tooltip> : null}</div>;
}